import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from 'src/app/core/services/shared/i18n/translation.service';
import { ThemeService } from './core/UIServices/theme.service';
import { RouterOutlet } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { AuthService } from './core/services/shared/Auth/auth.service';
import { PrimeNGConfig } from 'primeng/api';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    RouterOutlet,
    NgxSonnerToaster,
  ],
})
export class AppComponent {
  title = 'FacilityManagement';

 

 constructor(
   private readonly authService: AuthService,
   public themeService: ThemeService,
   private readonly translate: TranslateService,
   private readonly translationService: TranslationService,
   private readonly primengConfig: PrimeNGConfig
 ) {
   this.authService.getUserByToken().subscribe();
   const lang = this.translationService.getSelectedLanguage();
   this.translate.setDefaultLang(lang);
   this.translate.use(lang);
   // Dropdown overlays default to z-index 1000 while dialogs sit at 1100,
   // which blocks typing in the in-list search field.
   this.primengConfig.zIndex = {
     modal: 1100,
     overlay: 2000,
     menu: 1500,
     tooltip: 2100,
   };
 }
}
